export type OperacaoStatus = 'nova' | 'em_andamento' | 'pausada' | 'cancelada' | 'finalizada';

export const CORES_STATUS_OPERACAO: Record<OperacaoStatus, string> = {
  nova: '#ffcdcd',
  em_andamento: '#D0FFCB',
  pausada: '#ffe4bf',
  cancelada: '#CACACA',
  finalizada: '#CACACA'
};

export const STATUS_OPERACAO_OPTIONS: readonly { dado: OperacaoStatus }[] = [
  { dado: 'nova' },
  { dado: 'em_andamento' },
  { dado: 'pausada' },
  { dado: 'cancelada' },
  { dado: 'finalizada' }
] as const;
